import React from 'react';
import PropTypes from 'prop-types';

import { Navigation, Scrollbar, A11y , Autoplay   } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';
import icon from '../../assets/images/icon/ethe.svg'
import { Link } from 'react-router-dom';

Collection.propTypes = {
    data : PropTypes.array,
};

function Collection(props) {
    const {data} = props;
    return (
        <section className="tf-section tf-collection">
                <div className="tf-container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="tf-heading mb30 wow fadeInUp">
                                <h4 className="heading">Popular Bundles</h4>
                                <a className="button style-2" href="/explore">Browse<i className="fal fa-long-arrow-right"></i></a>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="collection-carousel wow fadeInUp">

                            <Swiper
                            modules={[Navigation,  Scrollbar, A11y , Autoplay ]}
                            spaceBetween={30}
                            breakpoints={{
                                0: {
                                    slidesPerView: 1,
                                    },
                                767: {
                                    slidesPerView: 2,
                                },
                                991: {
                                    slidesPerView: 3,
                                },
                                1300: {
                                    slidesPerView: 4,
                                },
                            }}
                            className=" product-category-1 pt10"
                            autoplay={{
                                delay: 2500,
                                disableOnInteraction: true,
                              }}
                            loop= {true}
                            pagination
                        >
                        {
                            data.slice(0,4).map(idx => (
                                <SwiperSlide key={idx.id}>
                                    <div className="slider-item">
                                                <div className="sc-product style1 collection">
                                                    <Link to="#">
                                                        <div className="thumb-collection">
                                                            <div className="left-thumb">
                                                                <img src={idx.img1} alt="images" />
                                                            </div>
                                                            <div className="right-thumb">
                                                                <div className="top-cl">
                                                                    <img src={idx.img2} alt="images" />
                                                                </div>
                                                                <div className="bottom-cl">
                                                                    <img src={idx.img3} alt="images" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                    <div className="tf-author">
                                                        <div className="content">
                                                            <Link to="#" className="name">{idx.name}</Link>
                                                        </div>
                                                        <div className="details-item">{idx.count}</div>
                                                    </div>
                                                    <div className="top">
                                                        <div className="content">
                                                            <div className="details"><span><img src={icon} alt="images" /></span> <Link to="#">{idx.price}</Link> </div>
                                                            <div className="price">{idx.pricesale}</div>
                                                        </div>
                                                        <div className="wish-list">
                                                            <Link to="#" className="heart-icon"></Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                </SwiperSlide>
                                
                            ))
                        }
                    </Swiper>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
    );
}

export default Collection;